import { type FC } from 'react';
import { Check } from '@phosphor-icons/react/dist/ssr';

import { cn } from '@/lib/utils';

import { P } from '@/components/atoms/Typography/P';

import { STEP_STATUS, type StepProps } from '../Stepper.types';

const Step: FC<StepProps> = ({ status, stepNumber }) => {
    const isChecked = status === STEP_STATUS.Checked;
    const isActive = status === STEP_STATUS.Active;
    const isComing = status === STEP_STATUS.Coming;

    const beforeLineClasses =
        "before:absolute before:left-0 before:[top:32px] before:w-6/12 before:border-t before:border-dashed before:border-gray-400 before:content-[''] first:before:content-none before:z-0";

    const afterLineClasses =
        "after:absolute after:right-0 after:[top:32px] after:w-6/12 after:border-t after:border-dashed after:border-gray-400 after:content-[''] last:after:content-none after:z-0";

    return (
        <li
            className={cn(
                'relative flex flex-1 flex-col items-center overflow-hidden p-2',
                beforeLineClasses,
                afterLineClasses,
            )}
        >
            <span
                className={cn(
                    'z-10 flex h-12 w-12 items-center justify-center rounded-full',
                    (isChecked || isComing) && 'bg-white',
                    isActive && 'bg-green-100',
                )}
            >
                <P
                    size="2xs"
                    weight="bold"
                    className={cn(
                        'flex h-8 w-8 items-center justify-center rounded-full',
                        (isChecked || isActive) && 'bg-green-500',
                        isComing && 'bg-grey-100',
                    )}
                >
                    {isChecked ? (
                        <Check
                            weight="bold"
                            size={20}
                        />
                    ) : (
                        stepNumber
                    )}
                </P>
            </span>
        </li>
    );
};

export default Step;
